// Tiny Web-Audio SFX for the scanning stations — no asset files needed.
let ctx = null;
function ac() {
  if (typeof window === "undefined") return null;
  const AC = window.AudioContext || window.webkitAudioContext;
  if (!AC) return null;
  if (!ctx) ctx = new AC();
  if (ctx.state === "suspended") ctx.resume();
  return ctx;
}

function tone(c, freq, start, dur, type, peak) {
  const osc = c.createOscillator();
  const g = c.createGain();
  osc.type = type;
  osc.frequency.value = freq;
  g.gain.setValueAtTime(0.0001, start);
  g.gain.exponentialRampToValueAtTime(peak, start + 0.012);
  g.gain.exponentialRampToValueAtTime(0.0001, start + dur);
  osc.connect(g);
  g.connect(c.destination);
  osc.start(start);
  osc.stop(start + dur + 0.03);
}

// kind: "ok" -> pleasant two-note chirp; "err" -> harsh low double-buzz.
export function beep(kind = "ok") {
  try {
    const c = ac();
    if (!c) return;
    const now = c.currentTime;
    if (kind === "err") {
      tone(c, 196, now, 0.18, "square", 0.22);
      tone(c, 160, now + 0.16, 0.26, "square", 0.22);
    } else {
      tone(c, 880, now, 0.10, "sine", 0.2);
      tone(c, 1318, now + 0.09, 0.14, "sine", 0.2);
    }
  } catch (e) {
    /* audio unavailable — non-blocking */
  }
}
